import { render, staticRenderFns } from "./tree_render.vue?vue&type=template&id=4c01b735&"
import script from "./tree_render.vue?vue&type=script&lang=js&"
export * from "./tree_render.vue?vue&type=script&lang=js&"
import style0 from "./tree_render.vue?vue&type=style&index=0&id=4c01b735&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports